const QualityBrands = () => {
    return (
        <section className="same_space pt-0 quality_brand">
            <div className="container">
                <div className="quality_brands_wepper">
                    <span>Quality Brands</span>
                    <h2>Brands we deal with</h2>
                    <div className="quality_logo_wepper">
                        <img src="images/brandlogo1.png" alt="" />
                        <img src="images/brandlogo2.png" alt="" />
                        {/* <!-- <img src="images/brandlogo3.png" alt="" />
                        <img src="images/brandlogo4.png" alt="" /> --> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default QualityBrands;